import React from 'react';
import MagicBento from './RemotePilotSmall/MagicBento';
import WhoCanApply from '../WhoCanApply';
import Hero from './RemotePilotSmall/Hero';
import About from '../About';
import CertificationMumbaiChandigarh from '../CertificationMumbaiChandigarh';

const RemotePilotSmall = () => {
  return (
    <>
      {/* Hero full width */}
      <Hero />
      {/* All other sections with same side margin & padding */}
      <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-6">
        <MagicBento />
        <About />
        <WhoCanApply />
        <CertificationMumbaiChandigarh />
      </div>
    </>
  );
};

export default RemotePilotSmall;
